module.exports = __webpack_public_path__ + "static/img/solar240130EN.f76505a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solar240130EN.jpg
// module id = AD1N
// module chunks = 1